<template>
  <a
    :class="classes"
    :style="ctaStyles"
    @click="handleClick($event)"
  >
    <span v-html="ctaText" />
  </a>
</template>

<script>
import GoogleAnalytics from '@Shared/lib/google-analytics'

export default {
  name: 'PackageCtaLink',
  props: {
    link: { type: String, default: null },
    text: { type: String, default: null },
    classModifier: { type: String, default: null },
    gaSettings: { type: Object, default: null },
    backgroundColor: { type: String, default: null }
  },
  data () {
    return {
      ctaText: null
    }
  },
  computed: {
    stringResources () {
      return this.$store.state.stringResources
    },
    classes () {
      let classes = [
        this.siteIdentityClass('package-cta-link')
      ]

      if (this.classModifier !== null) {
        classes.push(`package-cta-link--${this.classModifier}`)
      }

      return classes
    },
    ctaStyles () {
      let styles = {}

      if (this.backgroundColor !== null) {
        styles.backgroundColor = this.backgroundColor
      }

      return styles
    }
  },
  mounted () {
    if (this.text !== null) {
      this.ctaText = this.text
    } else {
      this.ctaText = this.stringResources.ViewAndCustomize
    }
  },
  methods: {
    handleClick ($event) {
      if (this.link === null) {
        window.alert('Not yet implemented')
        return
      }

      $event.preventDefault()
      window.location.href = this.link

      if (this.gaSettings !== null) {
        GoogleAnalytics.trackEvent(this.gaSettings.category, this.gaSettings.action, this.gaSettings.label)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../shared/scss/_cta';

.package-cta-link {
  @include cta(uppercase);

  &--ymal-carousel {
    font-size: 14px;
  }

  &--catalog-list-offer-group,
  &--ymal-carousel {
    background-color: #fff;
    color: $grad-color-blue;
    border: 2px solid $grad-color-blue;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
      background-color: #fff;
      outline: 4px solid $grad-color-blue;
      outline-offset: -2px;
      text-decoration: none;
    }
  }

  &--letter-jacket {
    background-color: $letterjacket-color-blue;
    border: 0;
    color: #fff;

    &:hover {
      background-color: $letterjacket-color-blue;
      border: 0;
      color: #fff;
      outline: none;
      text-decoration: underline;
    }
  }

  @media screen and (min-width: $screen-sm-min) {
    &--catalog-list-offer-group {
      font-size: 16px;
    }
  }

  @media screen and (min-width: $screen-md-min) {
    &--special-offer-carousel {
      font-size: 1.25vw;
    }
  }

  @media screen and (min-width: $screen-xxlg-min) {
    &--special-offer-carousel {
      font-size: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/catalog-list/components/PackageCtaLink.vue